import React from "react";
import { LangToggle, LANGUAGES } from "../api/Lang";
import { useMaintenanceStrings } from "./maintenance-strings";

export default function MaintenanceScreen({ message }: { message: string }) {
    const strings = useMaintenanceStrings();

    return (
        <div className="maintenance-screen">
            <div className="header" style={{ justifyContent: "right", padding: "30px 0" }}>
                <div className="header-profile">
                    <LangToggle langsOverride={LANGUAGES} edgeStyles={{ first: { marginLeft: "20px" }, last: { marginRight: "40px" } }} />
                </div>
            </div>
            <div className="maintenance-screen-body">
                <img className="maintenance-screen-logo" src="/img-assets/logo-compact-light.svg" alt="" />
                <img className="maintenance-screen-icon" src="/img-assets/closed.svg" alt="" />
                <p className="maintenance-screen-message">{message || strings.defaultMessage}</p>
            </div>
        </div>
    );
}
